import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { getDropdownValues } from 'gqlQueries/priceLadder';
import { priceLadderDropdownParser } from 'parser/priceLadderParser';
const errorMessage: string = 'Something went wrong!';

function useFetchDropdown2Data() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const [defaultCompetitorsList, setDefaultCompetitorsList] = useState<any[]>([]);
    const variablesRef = useRef<any>({});
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);

    const [fetchDropdownData, { data: landscapeData, loading: landscapeDataLoading, error: landscapeDataError }] =
        useLazyQuery(getDropdownValues, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPriceLadderCompetitorsDropdownValues } = payload;
            setCount(getPriceLadderCompetitorsDropdownValues?.count || 0);

            if (getPriceLadderCompetitorsDropdownValues && 'values' in getPriceLadderCompetitorsDropdownValues) {
                const parsedData = priceLadderDropdownParser(
                    getPriceLadderCompetitorsDropdownValues.values,
                    variablesRef.current?.attributeType,
                    variablesRef.current?.dimension,
                );
                if (variablesRef.current.offset === 0) {
                    setDefaultCompetitorsList(parsedData.defaultCount);
                }
                //request coming from infinite scroll
                if (variablesRef.current.offset !== 0 && data?.length > 0) {
                    setData([...data, ...parsedData?.result]);
                } else setData(parsedData?.result);
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setCount(0);
        setDefaultCompetitorsList([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        count,
        data,
        defaultCompetitorsList,
        fetchDropdownData: (variables: any) => {
            variablesRef.current = variables.variables;
            // only set data to null if function is being called outside/without infinite scroll
            // if offset is equal to default offset, it means request is coming without infinite scroll
            if (variables.variables.offset === 0) {
                setData(null);
            }
            setLoading(true);
            setError(null);
            fetchDropdownData(variables);
            // onFetchComplete(variables);
        },
    };
}

export { useFetchDropdown2Data };
